import AIAgentTemplate from './AIAgentTemplate';

// Compact wrapper for an FAQ-focused ElevenLabs agent using the reusable template.
// Configure via environment variables or hard-coded fallback.
const AIAgentSurg360 = () => {
  const agentId = import.meta.env.VITE_ELEVENLABS_SURG360_AGENT_ID;
  const title = 'Surg360';
  const subtitle = 'AI Agent';
  const suggestionCommands = [
    { label: 'surg 360', command: 'start surgical 360' }
  ];

  return (
    <AIAgentTemplate
      agentId={agentId}
      title={title}
      subtitle={subtitle}
      suggestionCommands={suggestionCommands}
      logoSrc="./logo-bw.png"
      logoAlt="Start"
      textOnly={false}
    />
  );
};

export default AIAgentSurg360;
